import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-user-agreement',
    templateUrl: './user-agreement.component.html',
    styleUrls: ['./user-agreement.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserAgreementComponent implements OnInit {

  privacyPolicyUrl = '/#/privacy';
  constructor() { }

  ngOnInit(): void {
  }

}
